// Import des images utilisées dans les news ........................................
// import imgnews0 from "../../../assets/img/img-news/inscriptionTournoi-450x300.jpg";
// import imgnews1 from "../../../assets/img/img-stages/PosterStages-2026-450x300.jpg";
import imgnews1 from "../../../assets/img/img-news/ag/ag-2026-tcf-450x300.png";
import imgnews2 from "../../../assets/img/img-news/Inscriptions/2027_Affiche inscription-450x300.png";
import imgnews3 from "../../../assets/img/img-pickleball/imgPickleball-jeu-450x300.png";
// import imgnews0 from "../../../assets/img/img-news/imgTournoiDoublesNoel-450x300.png";
// import imgnews4 from "../../../assets/img/img-news/venteGaufres-450x300.png";
// import imgnews5 from "../../../assets/img/img-news/choucroute-2026-450x300.png";
// import imgnews6 from "../../../assets/img/img-news/bonneannee2026-450x300.png";
// import imgnews6 from "../../../assets/img/img-news/bad-202603-450x300.png";
// import imgnews0 from "../../../assets/img/img-news/pickleball-202511-450x300.png";
// import imgnews0 from "../../../assets/img/img-news/article-progres-20241229-450x300.png";
// import imgnews1 from "../../../assets/img/img-news/Banner-TMC-TCF-450x300.png";
// import imgnews3 from "../../../assets/img/img-news/retardataire-450x300.png";
// import imgnewsX from "../../../assets/img/img-news/newBadge-450x300.png";
// import imgnewsX from "../../../assets/img/img-news/repriseCours-450x300.png";
// import imgnewsX from "../../../assets/img/img-news/TCF-OctobreRose2024-1068x632.jpeg";

// Import des fichiers affichés au clic sur les news ........................................
// import fileImgTournoiDoubles from "../../../assets/img/img-news/imgTournoiDoublesNoel-Resultat 2025.png";
// import videoNewYear from "../../../assets/video/bonneAnnee2026.mp4";
// import fileTournoi from "../../../assets/img/img-tournois/2026/posterTournoi-2026-422x597.jpg";
// import fileInscriptions from "../../../assets/img/img-news/Inscriptions/2027_Affiche inscription.pdf";
// import filePdfTournoiDoubles from "../../../assets/img/img-news/TournoiDoublesNoel-Inscription-2025.pdf";
// import videoGaufres from "../../../assets/video/venteDeGaufres.mp4";
// import fileImg from "../../../assets/img/img-news/TournoiDoublesNoel-Inscription-2025-450x300.png";
import fileImg from "../../../assets/img/img-news/ag/ag-2026-tcf-1055x1491.jpeg";

const tableNews = [
  {
    id: 1,
    img: imgnews1,
    title: "Assemblée Générale 2026",
    texte: "le vendredi 23 octobre à 19h.",
    texteGras: "Rendez-vous clubhouse route des dîmes.",
    file: fileImg, // Fichier à télécharger au clic.
    link: "#",
  },
  // {
  //   id: 1,
  //   img: imgnews1,
  //   title: "Stages de tennis 2026",
  //   texte: "Du 06 au 17 juillet.",
  //   texteGras: "Inscription au 📞 06 60 61 21 53",
  //   file: fileStages, // Fichier à télécharger au clic.
  //   link: "/enseignement#stagetennis",
  // },
  // {
  //   id: 6,
  //   img: imgnews0,
  //   title: "Tournoi de tennis 2026 - NC à 4/6",
  //   texte:
  //     "Les inscriptions sont ouvertes. Scannez le QR code ou cliquez sur l'image pour accéder directement à ten'up !.",
  //   texteGras: "Ouvert à tous les licenciés",
  //   file: fileTournoi, // Fichier à télécharger au clic.
  //   link: "https://tenup.fft.fr/tournoi/189831",
  // },
  {
    id: 2,
    img: imgnews2,
    title: "Adhésion au club 2027",
    texte: "Les inscriptions sont ouvertes ...",
    texteGras: "Venez nous rejoindre ...",
    file: "#",
    link: "/contact",
  },
  {
    id: 3,
    img: imgnews3,
    title: "Pickleball - Reprise des cours 2027",
    texte: "La reprise des cours va bientôt commencer ...",
    texteGras: "Venez vous inscrire ...",
    file: "#",
    link: "/contact",
  },
  // {
  //   id: 0,
  //   img: imgnews6,
  //   title: "BONNE ANNÉE 2026 !!",
  //   texte: "Le TCF vous présente ses meilleurs voeux pour 2026 et de ",
  //   texteGras: "nombreuses victoires pour 2026 !!",
  //   file: videoNewYear,
  //   link: "#",
  // },
  // {
  //   id: 1,
  //   img: imgnews0,
  //   title: "Tournoi de Doubles de Noël 2025",
  //   texte:
  //     "La finale du tournoi s'est déroulée le 03/01/2026. Bravo à tous les participants !",
  //   texteGras: "Victoire de FX Gatinet & JP Sassot vs B. Clair & A. Deshenry",
  //   file: fileImgTournoiDoubles, // Fichier à télécharger au clic.
  //   link: "#",
  // },
  // {
  //   id: 5,
  //   img: imgnews5,
  //   title: "Choucroute 2026",
  //   texte: "Vente de choucroute et de bières allemandes. Vite, je commande ...",
  //   texteGras: "Téléchargez le bon de commande ...",
  //   file: filepdf, // Fichier à télécharger au clic.
  //   link: "#",
  // },
  // {
  //   id: 2,
  //   img: imgnews4,
  //   title: "Vente de gaufres",
  //   texte: "vente sur place le 20/12/2025.",
  //   texteGras: "Venez nombreux ...",
  //   file: videoGaufres, // Fichier à télécharger au clic.
  //   link: "#",
  // },
  // {
  //   id: 1,
  //   img: imgnews1,
  //   title: "TMC - Tournoi Multi-Chances",
  //   texte: "Compétition interne. ",
  //   texteGras: "Le TMC Dames est programmé le dimanche 23/2.",
  //   file: "#",
  //   link: "#",
  // },
  // {
  //   id: 0,
  //   img: imgnewsX,
  //   title: "Après-midi Octobre ROSE",
  //   texte:
  //     "Journée au profit de l'association - Les Fées Papillons. Venez nombreux à partir de 14h ...",
  //   texteGras: "RENSEIGNEZ-VOUS ...",
  //   file: "#",
  //   link: "#",
  // },
  // {
  //   id: 4,
  //   img: imgnewsX,
  //   title: "Licences d'été 2024",
  //   texte:
  //     "Les adhésions pour bénéficier des courts de tennis durant l'été (juin, juillet, août) sont ouvertes => Tarif Adulte : 55 €. CONTACTEZ-NOUS !",
  //   texteGras: "RENSEIGNEZ-VOUS ...",
  //   file: "#",
  //   link: "#",
  // },
];

export default tableNews;
